import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { appConfig, isOktaConfigured } from "../config/appConfig";

const OktaConfiguration = ({ children }) => {
  const navigate = useNavigate();

  const oktaAuth = useMemo(() => {
    if (!isOktaConfigured) {
      return null;
    }

    return new OktaAuth({
      issuer: appConfig.oktaIssuer,
      clientId: appConfig.oktaClientId,
      redirectUri: `${window.location.origin}/login/callback`,
      pkce: true,
      scopes: appConfig.oktaScopes,
    });
  }, []);

  if (!oktaAuth) {
    return children;
  }

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin), { replace: true });
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

export default OktaConfiguration;
